import React from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { RootState } from '../../../../redux/store';
import { MODAL } from '../../../../redux/types';

import Icon from '../../icon/icon';
import PopupWrapper from '../popupWrapper/popupWrapper';

import './multipleDownload.scss';

export const MultipleDownloadModal: React.FC = () => {
  const dispatch = useDispatch();

  const showPopup = useSelector((state: RootState) => state.multipleDownload.showModal);
  const popupInfo = useSelector((state: RootState) => state.multipleDownload.modalInfo);

  const close = () => {
    dispatch({ type: MODAL.CLOSE_MULTIPLE_DOWNLOAD_MODAL });
  };

  return showPopup && (
    <PopupWrapper
      className={`multiple-download-popup-wrapper ${popupInfo && popupInfo.error ? 'multiple-download-popup-error' : ''}`}
      onClose={close}>
      {popupInfo && popupInfo.error && <Icon name='far fa-circle-exclamation' className='danger-icon' />}
      <div className='multiple-download-popup-body'>
        {popupInfo && <span>{popupInfo.text}</span>}
      </div>
    </PopupWrapper>
  );
};

export default MultipleDownloadModal;
